import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const AssetField = ({ field, form, setForm, type = 'text', required = false, ...props }) => {
  const { t } = useTranslation();
  return <div className="space-y-1.5 min-w-0">
    <Label htmlFor={`asset-${field}`}>{t(`assets.fields.${field}`)}{required ? ' *' : ''}</Label>
    <Input id={`asset-${field}`} data-testid={`asset-${field.replaceAll('_', '-')}-input`} type={type}
      value={form[field] ?? ''} required={required} onChange={e => setForm(prev => ({ ...prev, [field]: e.target.value }))} {...props} />
  </div>;
};

export const AssetSelect = ({ id, label, value, onChange, options, disabled = false }) => <div className="space-y-1.5 min-w-0">
  <Label htmlFor={id}>{label}</Label>
  <Select value={value} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger id={id} data-testid={id} className="w-full min-w-0"><SelectValue /></SelectTrigger>
    <SelectContent data-testid={`${id}-menu`}>{options.map(option => <SelectItem key={option.value} value={option.value} data-testid={`${id}-${option.value}`}>{option.label}</SelectItem>)}</SelectContent>
  </Select>
</div>;